// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".partnership-card-footer{margin-top:25px;justify-content:space-between;align-items:center}.partnership-card-footer .dashboard-col{flex:unset}.partnership-card-footer .dashboard-col img{height:50px}\n", ""]);
// Exports
module.exports = exports;
